module.exports = __webpack_public_path__ + "img/number_5.11be0b41.png";